import { MultiStepFormState } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form-item';
import {
  MultiStepFormProvider,
  SubmitHandlerWithDirtyFields,
} from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { RemoteStartTransactionModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/inputs/charge-point/ocpp/remote-start-transaction.model';
import { SubmitErrorHandler } from 'react-hook-form';

import { useStartChargePointChannelTransactionContext } from '../../charge-point.context';
import { ChargePointChannelTransactionStartFormStep1Controller } from '../charge-point-channel-transaction-start-form-step-1/charge-point-channel-transaction-start-form-step-1.controller';

export interface ChargePointChannelTransactionStartFormControllerProps {
  onError: SubmitErrorHandler<
    Pick<
      RemoteStartTransactionModel,
      'chargePointId' | 'channelId' | 'tokenIdentifier'
    >
  >;
  onSubmit: SubmitHandlerWithDirtyFields<
    Pick<
      RemoteStartTransactionModel,
      'chargePointId' | 'channelId' | 'tokenIdentifier'
    >
  >;
  onCancel: () => void;
  state: MultiStepFormState;
}

export const ChargePointChannelTransactionStartFormController = (
  props: ChargePointChannelTransactionStartFormControllerProps,
): React.JSX.Element => {
  const { onError, onSubmit, onCancel, state } = props;
  const data = useStartChargePointChannelTransactionContext();

  return (
    <MultiStepFormProvider<
      Pick<
        RemoteStartTransactionModel,
        'chargePointId' | 'channelId' | 'tokenIdentifier'
      >
    >
      useFormProps={{
        mode: 'all',
        defaultValues: data,
      }}
      submitErrorHandler={onError}
      submitHandler={onSubmit}
      onCancel={onCancel}
      state={state}
      items={[
        {
          fields: ['chargePointId', 'channelId', 'tokenIdentifier'],
          component: <ChargePointChannelTransactionStartFormStep1Controller />,
        },
      ]}
    />
  );
};
